













import { defineComponent } from '@vue/composition-api';
import { SvgImage } from '@/app/components';

export default defineComponent({
    name: 'CombinedMetrics',
    props: {
        id: {
            type: [Number, String],
            required: true,
        },
    },
    components: {
        SvgImage,
    },
});
